import { render, staticRenderFns } from "./exhibitor-channel-posts.vue?vue&type=template&id=1a6fe17c&scoped=true"
import script from "./exhibitor-channel-posts.vue?vue&type=script&lang=js"
export * from "./exhibitor-channel-posts.vue?vue&type=script&lang=js"
import style0 from "./exhibitor-channel-posts.vue?vue&type=style&index=0&id=1a6fe17c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6fe17c",
  null
  
)

export default component.exports